/**
 * The old sign-up and sign-in pages (/landing/signup, /landing/signin) now open the entry page
 * (/welcome) with the matching tab of the account panel. Everything the link carried stays: the
 * website's ad parameters, `redirectTo`, `lp`, `exp`.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { Routes } from 'enums';

const RedirectToEntry: React.FC<{ tab: 'signup' | 'login' }> = ({ tab }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('auth', tab);
  return <Navigate to={{ pathname: Routes.PUBLIC_CHAT, search: `?${params.toString()}`, hash: location.hash }} state={location.state} replace />;
};

export default RedirectToEntry;
